import { render } from "./epk.vue?vue&type=template&id=70154089"
import script from "./epk.vue?vue&type=script&lang=js"
export * from "./epk.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jmallach/Dev/jicub/vuejs-bosb-microsite/my-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__